import { type AnagraficaApplicazione } from '@framework/api-client/api/users/schemas/anagraficaApplicazione.ts';
import { type ConfigurazioneApplicazione } from '@framework/api-client/api/users/schemas/configurazioneApplicazione.ts';
import { EnumAnagraficaApplicazioneProtocollazionePrincipale as ClientConfigPrincipalProtocol } from '@framework/api-client/api/users/schemas/enumAnagraficaApplicazioneProtocollazionePrincipale.ts';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { shallowEqual, useSelector } from 'react-redux';

export interface ClientConfigState {
  applicationConfig?: AnagraficaApplicazione;
  /** Nome dell'applicazione (visibile) */
  displayName?: string | null;
  /** Protocollo principale RICHIESTA | DOCUMENTO, per il backoffice. */
  principalProtocol?: ClientConfigPrincipalProtocol | null;
  /** Configurazioni dedicate */
  jsonConfig?: ConfigurazioneApplicazione | null;
  /** Abilita l'area pubblica */
  enablePublicArea?: boolean | null;

  /** Indica se la configurazione è stata caricata */
  isLoaded: boolean;
}

export { ClientConfigPrincipalProtocol };

export interface IRootClientConfigState {
  clientConfig: ClientConfigState;
}

/**
 * Gestiamo la configurazione (AnagraficaApplicazione) del client.
 * Il tutto è gestito in `Auth` perché è necessario essere autenticati per
 * poter accedere a queste informazioni.
 */
export const ClientConfigSlice = createSlice({
  name: 'clientConfig',
  initialState: () => ({ isLoaded: false }) as ClientConfigState,
  reducers: {
    setClientConfig: (state, action: PayloadAction<AnagraficaApplicazione>) => {
      return {
        ...state,
        applicationConfig: action.payload,
        displayName: action.payload.denominazione,
        principalProtocol: action.payload.protocollazionePrincipale,
        enablePublicArea: action.payload.flAreaPubblica,
        jsonConfig: {
          ...action.payload.configurazioneJson,
        },
        isLoaded: true,
      };
    },
  },
});

export const ClientConfigActions = ClientConfigSlice.actions;

/**
 * Ottiene la configurazione dell'applicazione.
 */
export const useClientConfig = () =>
  useSelector(
    (state: IRootClientConfigState) =>
      state.clientConfig ?? { isLoaded: false },
    shallowEqual,
  );
